import { connect } from 'react-redux';
import { Profile as ProfileComponent } from './profile.component';
import { getUserData } from '../../authentication/authentication.actions';

export const Profile = connect(sState => ({ sState }), {
  getUserData
})(ProfileComponent);